import {
  Typography,
  Stack,
  Grid,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Container,
  Button
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useEffectOnce, useToggle } from "react-use";
import UploadFileModal from "./uploadModal";
import UploadFolderModal from "./uploadFolderModal";
import {
  getFiles,
  deleteFile,
  getAllUsers,
  getAccessUsers,
  downloadFile,
  uploadSelector
} from "../store/slices/upload";
import { useDispatch, useSelector } from "react-redux";
import PreviewModal from "./previewModal";
import ConfirmBox from "./modals/confirmBox";
import FilterSideBar from './filtersSideBar'
import UploadIcon from '@mui/icons-material/Upload'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SideBar from './sideBar';
import FileTable from './fileTable';
import DeleteIcon from '@mui/icons-material/Delete'
import DownloadIcon from '@mui/icons-material/Download'
import _ from "lodash";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import CloseIcon from '@mui/icons-material/Close'
import { countFiles, getExactFolderName, getFileName, getExtension, getDataUrl, getMimeType } from "../common/utils";
import FileViewer from 'react-file-viewer';

function base64ToBlob(base64, mimeType) {
  if(base64)
  {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);
    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: mimeType });
}
}

const Welcome = () => {
  const dispatch = useDispatch();
  const [showUploadFile, toggleUploadFile] = useToggle(false);
  const [showUploadFolder, toggleUploadFolder] = useToggle(false);
  const [filters, toggleFilter] = useToggle(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showDocViewer, toggleDocViewer] = useToggle(false);
  const [showIn, setShowIn] = useState(1);
  const [confirmationOpen, toggleConfirmationOpen] = useToggle(false);
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [groupId, setGroupId] = useState(localStorage.getItem("userId"));
  const [rowSelection, setRowSelection] = useState({ files: [], folders: [],mainFolders:[],isAllSelected:false });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { selectedFile } = useSelector(uploadSelector);
  const [type, setType] = React.useState(_.lowerCase(getExtension(selectedRow?.name)));
  const [multipleDeleteConfirmationOpen, toggleMultipleDeleteConfirmationOpen] = useToggle(false);
  const [internalGroup, setInternalGroup] = React.useState([]);
  const open = Boolean(anchorEl);
  
  useEffectOnce(() => {
    dispatch(getFiles(localStorage.getItem("userId")));
    dispatch(getAllUsers());
    dispatch(getAccessUsers(localStorage.getItem("userId")));
  }, []);

  const handleDeleteRequest = () => {
    dispatch(deleteFile([{ path: selectedRow?.path, userId: localStorage.getItem("userId") }]));
    toggleConfirmationOpen();
  };
  const handleMultipleDeleteRequest = () => {
    let request = [];
    if (rowSelection.files.length > 0) {
      _.map(rowSelection.files, item => {
        let name = item.split("/")
        request.push({ path: _.compact(name).join("/"), userId: localStorage.getItem("userId") })
      })
      dispatch(deleteFile(request));
      toggleMultipleDeleteConfirmationOpen();
      setRowSelection({ files: [], folders: [],isAllSelected:false,mainFolders:[] })
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onDownloadClick = () => {
    let requestObj=[];
    let filesToBeDownload=rowSelection.files;
    let foldersToBeDownload=[];
    _.map(rowSelection.mainFolders,folder=>{
      foldersToBeDownload.push({name:getExactFolderName(folder),files:_.map(_.filter(filesToBeDownload,it=>_.includes(it,folder)),file=>{return {path:file,name:getFileName(file)}})})
      filesToBeDownload=_.filter(filesToBeDownload,it=>!_.includes(it,folder))
    })
    _.map(filesToBeDownload,file=>{
        requestObj.push({path:file,name:getFileName(file)})
    })
    if (filesToBeDownload.length > 0 || foldersToBeDownload.length>0)
      dispatch(downloadFile({files: requestObj,folders:foldersToBeDownload}));
  };
  const onDeleteClick = () => {
    toggleMultipleDeleteConfirmationOpen();
  };
  React.useEffect(()=>{
          setType(_.lowerCase(getExtension(selectedRow?.name)))
      },[selectedRow])
  
      const showFile = () => {
          var preview = document.getElementById('show-text');
          if(selectedFile && type=='txt')
          {
              var data=atob(selectedFile);
              if(data)
                  preview.innerHTML = data;
          }
          
         
        }
  
        React.useEffect(()=>{
          showFile(selectedFile)
        },[selectedFile])
     
      const finalData = React.useMemo(() => getDataUrl(selectedRow?.name,selectedFile), [selectedRow, selectedFile,type]);
      // if(selectedFile)
      // {
      //   const blob =React.useMemo(() => base64ToBlob(selectedFile, getMimeType(selectedRow?.name)), [selectedFile]);
      //   const url =React.useMemo(() => URL.createObjectURL(blob), [blob]);
      // }
      
        
  return (
    <>
    {!showDocViewer && <Box style={{ width: '100%' }} spacing={2}>
      <Grid container spacing={2} sx={{ mb: 2, pt: 1 }}>

        <Grid item xs={2} md={2} lg={2} xl={2} wide={2}>
          <SideBar
            open={filters}
            toggle={toggleFilter}
            selectedUser={selectedUser} setSelectedUser={setSelectedUser}
            setSelectedTypes={setSelectedTypes}
            selectedTypes={selectedTypes}
            groupId={groupId} setGroupId={setGroupId} />
        </Grid>
        <Grid item xs={10} md={10} lg={10} xl={10} wide={10} sx={{ pr: 2 }}>
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              marginBottom: 2,
              width: "100%",
              justifyContent: 'space-between'
            }}
          >
            <>
              <Typography>Welcome User!</Typography>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: "150px" }}>
                {
                  <span>
                      <IconButton
                        onClick={(event) => {
                          handleClick(event)
                        }}
                        sx={{
                          height: '50px',
                          color: '#727272',
                          fontSize:'1.0286rem',
                          backgroundColor:'#fff',
                          width: '140px',
                          ':hover': {
                            color: '#007bff',
                            backgroundColor:'#fff',
                          }
                        }}
                        variant='outlined' color='secondary'><UploadIcon sx={{fontSize:'1.4142857142857142rem',color: '#007bff'}} />Upload<ExpandMoreIcon/></IconButton>
                    <div>

                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                        keepMounted
                        sx={{ width: 250 }}
                      >
                        <MenuItem sx={{width:120}} onClick={() => { toggleUploadFile(true) }}>File</MenuItem>
                        <MenuItem sx={{width:120}} onClick={() => { toggleUploadFolder(true) }}>Folder</MenuItem>
                      </Menu>
                    </div>
                  </span>}
                {(rowSelection.files.length > 0) && <><Tooltip title='Download Files' arrow disableInteractive><span>
                  <IconButton
                    onClick={() => {
                      onDownloadClick();
                    }}
                    sx={{
                      height: '50px',
                      color: '#727272',
                      fontSize:'1.0286rem',
                      width: '110px',
                      backgroundColor:'#fff',
                      ':hover': {
                        color: '#007bff',
                        backgroundColor:'#fff',
                      }
                    }}
                    variant='outlined' color='secondary'><DownloadIcon sx={{fontSize:'1.4142857142857142rem',color: '#007bff'}}/>Download</IconButton>
                </span></Tooltip>
                  <Tooltip title='Delete Files' arrow disableInteractive><span>
                    <IconButton
                      onClick={() => {
                        onDeleteClick();
                      }}
                      sx={{
                        height: '50px',
                        color: '#727272',
                        width: '110px',
                        fontSize:'1.0286rem',
                        backgroundColor:'#fff',
                        ':hover': {
                          color: '#007bff',
                          backgroundColor:'#fff',
                        }
                      }}
                      variant='outlined' color='secondary'><DeleteIcon sx={{fontSize:'1.4142857142857142rem',color: '#007bff'}}/>Delete</IconButton>
                  </span></Tooltip>
                  <Tooltip title='Clear' arrow disableInteractive><span>
                    <IconButton
                      onClick={() => {
                        setRowSelection({ files: [], folders: [],isAllSelected:false,mainFolders:[] });
                      }}
                      sx={{
                        height: '50px',
                        color: '#727272',
                        width: '150px',
                        fontSize:'1.0286rem',
                        backgroundColor:'#fff',
                        ':hover': {
                          color: '#007bff',
                          backgroundColor:'#fff',
                        }
                      }}
                      variant='outlined' color='secondary'><CloseIcon sx={{fontSize:'1.4142857142857142rem',color: '#007bff'}}/>{countFiles(rowSelection.files,rowSelection.folders,rowSelection.mainFolders)} Selected</IconButton>
                  </span></Tooltip></>}
              </div>

              {<Tooltip title='Open filter panel' arrow disableInteractive><span>
                <IconButton
                  onClick={() => {
                    toggleFilter(true);
                  }}
                  sx={{
                    height: '50px',
                    color: '#727272',
                    width: '110px',
                    fontSize:'1.0286rem',
                    backgroundColor:'#fff',
                    ':hover': {
                      color: '#007bff',
                      backgroundColor:'#fff',
                    }
                  }}
                  variant='outlined' color='secondary'><FilterAltIcon sx={{fontSize:'1.4142857142857142rem'}} /></IconButton>
              </span></Tooltip>}

            </>
          </Stack>

          <FileTable selectedRow={selectedRow} setSelectedRow={setSelectedRow} toggleDocViewer={toggleDocViewer}
            groupId={groupId} rowSelection={rowSelection} setRowSelection={setRowSelection} setShowIn={setShowIn}
            toggleConfirmationOpen={toggleConfirmationOpen} selectedUser={selectedUser} selectedTypes={selectedTypes} 
            internalGroup={internalGroup} setInternalGroup={setInternalGroup}/>
        </Grid>
      </Grid>

      <UploadFileModal btnName={"Save"} open={showUploadFile} toggle={toggleUploadFile}/>
      <UploadFolderModal btnName={"Save"} open={showUploadFolder} toggle={toggleUploadFolder} />
      {/* <PreviewModal
        open={showDocViewer}
        toggle={toggleDocViewer}
        selectedRow={selectedRow?.name}
      /> */}
      <ConfirmBox
        setOpenModal={toggleConfirmationOpen}
        openModal={confirmationOpen}
        onConfirm={handleDeleteRequest}
        confirmMessage={"Are you sure you want to delete this file?"}
        title={'Delete File(s)/Folder(s)'}
      />
      <FilterSideBar
        open={filters}
        toggle={toggleFilter}
        selectedUser={selectedUser} setSelectedUser={setSelectedUser}
        setSelectedTypes={setSelectedTypes}
        selectedTypes={selectedTypes} />
      <ConfirmBox
        setOpenModal={toggleMultipleDeleteConfirmationOpen}
        openModal={multipleDeleteConfirmationOpen}
        onConfirm={handleMultipleDeleteRequest}
        confirmMessage={"Are you sure you want to delete selected file(s)/folders(s)?"}
        title={'Delete File(s)/Folder(s)'}
      />
      
    </Box>}
    {showDocViewer && <Box style={{ width: '100%' }} spacing={2}>
    <Button variant='text' sx={{float:'right',mt:'5px',mr:'5px'}} onClick={() => { toggleDocViewer() }}>
                        Close
                    </Button>
      <Container maxWidth="xl" sx={{mt:5,marginLeft:'125px'}}>
                              <Box sx={{ height: 'calc(100vh - 200px)', width: 'calc(100vw - 300px)',padding: "20px", background: "#f1f1f1" ,paddingBottom:"40px" }} >
                                  {type=='txt' && 
                                  <div id="show-text"></div>}
                                  {selectedFile && !(type=='svg'|| type=='tiff' || type=='webp' || type=='txt') &&
                                  <FileViewer
                                      fileType={type}
                                      filePath={finalData}
                                      //height= {'calc(100vh - 350px)'}
                                      //width={'calc(100vw - 500px)'}
                                  />}
                                  {(type=='svg' || type=='tiff' || type=='webp')  && !(type=='txt') &&
                                  <Container fixed maxWidth={'xl'} sx={{ height: 'calc(100vh - 400px)', width: 'calc(100vw - 740px)' }}><img src={finalData}
                                  /></Container>}
                                {/* <iframe src={`https://docs.google.com/viewer?url=${encodeURIComponent(selectedRow?.uri)}&embedded=true`} width="100%" height="500px"></iframe> */}
                                {/* <iframe 
                                  src={finalData}
                                  width="100%" 
                                  height="600px">
                                </iframe> */}
                                {/* <iframe
  src={base64ToBlob(selectedFile, getMimeType(selectedRow?.name))}
  width="100%"
  height="600px"
  title="DOCX Preview"
></iframe> */}
                              </Box>
      
                          </Container>
      
    </Box>}
    </>
    
  );
};

export default Welcome;
